import { getAxiosClient } from "../../axios-client";
import { AddPackageRequestBody, AddPackageResponse } from "./types";

const axiosClient = getAxiosClient();
export const addPackage = async (body: AddPackageRequestBody) => {
  return await axiosClient.ax.post<AddPackageResponse>("/Packages/Add", body);
};
